export function titleCase(str) {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(' ');
}

// export  function ParseFloat(str,val) {
//     str = str.toString();
//     str = str.slice(0, (str.indexOf(".")) + val + 1); 
//     return Number(str);   
// }

export function ParseFloat(str) {
return Number(str).toFixed(2);
}

export const lastFiveDigitsComparator = (a, b) => {
  const getLastFiveDigits = (value) => {
      const lastFive = value.substring(value.length-5);
      return lastFive;
  };
  return getLastFiveDigits(a) - getLastFiveDigits(b);
};

export function GetRecentCommentObject(commentsArray) {
  return commentsArray?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))[0]
}

export const handleNumberFieldFocus = (e) => {
   e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })
}